import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class TenantInterceptorService implements HttpInterceptor {
  constructor(private localStorageService: LocalStorageService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantId = this.localStorageService.getTenantId();
    const isTenantRequest = request.url.includes('/tenant/');

    if (isTenantRequest && tenantId && tenantId !== 'central') {
      request = request.clone({
        setHeaders: {
          'X-Tenant': tenantId,
        },
      });
    }

    return next.handle(request);
  }
}
